import { PartnerAccount } from '@tmx/data-access';
import { map, pipe } from 'rxjs';

export function groupAccounts() {
  return pipe(
    map<
      PartnerAccount[],
      { partnerAccounts: PartnerAccount[]; customerAccounts: PartnerAccount[] }
    >((accounts) => {
      const partnerAccounts: PartnerAccount[] = [];
      const customerAccounts: PartnerAccount[] = [];

      accounts.forEach((account) => {
        if (account.alias === '') {
          return;
        }

        if (account.companyType === 'Partner') {
          partnerAccounts.push(account);
        } else {
          customerAccounts.push(account);
        }
      });

      return { partnerAccounts, customerAccounts };
    })
  );
}
